import type { Comic } from "@/mocks/comicData";

interface ComicCardProps {
  comic: Comic;
  badge?: string;
}

export default function ComicCard({ comic, badge }: ComicCardProps) {
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.imageUrl}
          alt={`${comic.title} 漫画封面 - ${comic.genre}`}
          title={`${comic.title} · ${comic.genre} · 动漫之家漫画网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent" />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-1 text-xs font-medium text-background-50">
          {badge || comic.tag}
        </span>
        {comic.status === '已完结' && (
          <span className="absolute right-2 top-2 rounded-md bg-background-950/70 px-2 py-1 text-xs text-background-50 backdrop-blur">
            完结
          </span>
        )}
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between text-background-50">
          <span className="flex items-center gap-1 text-sm font-bold">
            <i className="ri-star-fill text-accent-500"></i>
            {comic.rating}
          </span>
          <span className="text-xs text-background-100">{comic.chapters}</span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h4 className="truncate text-sm font-bold text-foreground-900 md:text-base">
          {comic.title}
        </h4>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-600">
          <span>{comic.genre}</span>
          <span className="text-foreground-300">·</span>
          <span>{comic.authors}</span>
        </p>
        <p className="mt-2 line-clamp-2 hidden text-xs leading-relaxed text-foreground-500 sm:block">
          {comic.description}
        </p>
      </div>
    </article>
  );
}